export const SDK_NAME = "hiero-sdk-js";
export const SDK_VERSION =
    typeof __SDK_VERSION__ !== "undefined" ? __SDK_VERSION__ : "DEV";
